import { call, put, takeLatest } from 'redux-saga/effects';

import { currentCompany, notification } from '../../../actionTypes';
import dataProvider from '../../../store/dataProvider';

export function* get({ payload: { ownerCompanyId, contractorCompanyId } }) {
  try {
    const { data: questions } = yield call(
      dataProvider.getList,
      `companies/${ownerCompanyId}/owner-working-hours/questions`,
      {},
    );
    const { data: allAnswers } = yield call(
      dataProvider.getList,
      `companies/${ownerCompanyId}/owner-working-hours/${contractorCompanyId}/answers`,
      {},
    );

    const questionIds = questions.map(q => q.id);
    const answers = allAnswers.filter(answer => questionIds.includes(answer.formBuilderFieldId));

    yield put({
      type: currentCompany.contractorWorkingHoursAnswers.get.end,
      payload: { questions: questions.sort((a, b) => a.order - b.order), answers },
    });
  } catch (e) {
    yield put({ type: notification.add, payload: { error: e.message } });
    yield put({ type: currentCompany.contractorWorkingHoursAnswers.get.error });
  }
}

export default function* getWorkingHoursAnswersSaga() {
  yield takeLatest(currentCompany.contractorWorkingHoursAnswers.get.start, get);
}
